import {
  base_colorContentBorder,
  base_colorRaisedSurface,
  base_colorSurfaceMuted,
  tag_colorTagNewBackground,
  tag_colorTagNewText,
  text_colorTextPrimary,
  text_colorTextSecondary,
  tooltip_colorSpotlightSurface,
} from 'ext-ui/style/colors'
import { cornerRadius, spacing } from 'ext-ui/style/spacing'
import {
  font_family_weight_medium,
  font_lg,
  font_md,
} from 'ext-ui/style/typography'
import { css } from 'styled-components'

export const trigger = css`
  width: ${spacing(8)};
  height: ${spacing(8)};
  flex: 0 0 ${spacing(8)};
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  border: 0;
  border-radius: ${spacing(2)};
  background: ${tag_colorTagNewBackground};
  color: ${tag_colorTagNewText};
  cursor: pointer;

  &:hover {
    filter: brightness(0.97);
  }

  &:focus-visible {
    outline: 2px solid ${tag_colorTagNewText};
    outline-offset: ${spacing(1)};
  }
`

export const popper = css`
  z-index: 1300;
`

export const dialog = css`
  width: min(430px, calc(100vw - ${spacing(8)}));
  display: flex;
  flex-direction: column;
  gap: ${spacing(4)};
  padding: ${spacing(5)};
  border: 1px solid ${base_colorContentBorder};
  border-radius: ${cornerRadius};
  background: ${base_colorRaisedSurface};
  box-shadow: 0 8px 28px rgba(27, 44, 79, 0.16);
  color: ${text_colorTextPrimary};
`

export const header = css`
  display: flex;
  align-items: center;
  gap: ${spacing(3)};
`

export const agentIcon = css`
  position: relative;
  width: ${spacing(10)};
  height: ${spacing(10)};
  flex: 0 0 ${spacing(10)};
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  background: ${tooltip_colorSpotlightSurface};
`

export const agentMark = css`
  width: ${spacing(6)};
  height: ${spacing(6)};
`

export const agentBadge = css`
  position: absolute;
  right: -${spacing(1)};
  bottom: -${spacing(1)};
  width: ${spacing(5)};
  height: ${spacing(5)};
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border: 2px solid ${base_colorRaisedSurface};
  border-radius: 50%;
  background: ${tag_colorTagNewBackground};
`

export const title = css`
  ${font_lg};
  margin: 0;
  flex: 1;
  font-family: ${font_family_weight_medium};
  color: ${text_colorTextPrimary};
`

export const closeButton = css`
  margin: -${spacing(2)};

  &:not(:hover) {
    background: transparent;
  }
`

export const context = css`
  ${font_md};
  margin: 0;
  padding: ${spacing(3)} ${spacing(4)};
  border-radius: ${cornerRadius};
  background: ${base_colorSurfaceMuted};
  color: ${text_colorTextSecondary};
`

export const composer = css`
  display: flex;
  align-items: flex-end;
  gap: ${spacing(2)};

  > div {
    min-width: 0;
    flex: 1;
  }
`

export const input = css`
  .textbox-container {
    min-height: ${spacing(11)};
  }
`

export const sendButton = css`
  min-width: ${spacing(18)};
  height: ${spacing(11)};
  flex: 0 0 auto;
`
